import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router';

const ScrollToTop = () => {
  const { pathname, state } = useLocation();
  const isInitialMount = useRef(true);

  useLayoutEffect(() => {
    // En el mount inicial (load/refresh) no tocamos el scroll
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    // En navegación entre páginas, ir al tope (salvo que haya anchor destino)
    if (!state?.scrollTo) {
      document.getElementById('top')?.scrollIntoView({ behavior: 'instant' });
    }
  }, [pathname, state]);

  return null;
};

export default ScrollToTop;
